const siteConfig = {
  brandName: "miskergarden",
  wordmark: "MISKERGARDEN",
  logo: "/head/miskergarden-lockup.svg",
  description:
    "A considered wardrobe of enduring menswear, inspired by quiet gardens and made for everyday life.",
  website: "https://www.miskergarden.garden",
  locale: "en-US",
  currency: "USD",
  orderPrefix: "MGR",
  contact: {
    email: "power@miskergarden.garden",
    hours: "Monday to Friday, 9am–6pm HKT",
    company: "HONGKONG STAR UNION LIMITED",
    address:
      "FLAT C, 8/F TSUN WIN FACTORY BUILDING, 60 TSUN YIP STREET, KWUN TONG, HK",
  },
  shipping: {
    freeThreshold: 200,
    standardCost: 12,
    returnsWindow: 30,
  },
  social: {},
  navigation: [
    { label: "New in", to: "/shop?tag=new" },
    { label: "Shirts", to: "/shop?category=Shirts" },
    { label: "Knitwear", to: "/shop?category=Knitwear" },
    { label: "Jackets", to: "/shop?category=Jackets" },
    { label: "Trousers", to: "/shop?category=Trousers" },
    { label: "Shoes", to: "/shop?category=Shoes" },
  ],
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);

export default siteConfig;
